import { UpdatesSystem } from '@aninix-inc/model'
import { useProject } from '@aninix/core'

export const useUpdates = () => {
  const project = useProject()
  const updates = project.getSystemOrThrow(UpdatesSystem)
  return updates
}
